module.exports = __webpack_public_path__ + "img/btn_copy.08eb3389.png";